
// Function to compare common cue properties
export default function areCommonPropsEqual(prevProps, nextProps) {
  const topLevelKeysToCompare = ['baseTheme', 'baseThemeId'];
  const cueKeysToCompare = [
    'theme', 'transition', 'position', 'scale', 'offsetX', 'offsetY',
    'rotate', 'crop', 'onAirDuration', 'linkedTo', 'linkedDelay',
    'outputOne', 'outputTwo', 'outputThree', 'outputFour', 'outputUtility'
  ];

  const topLevelEqual = topLevelKeysToCompare.every(key => prevProps[key] === nextProps[key]);
  const cueEqual = cueKeysToCompare.every(key => prevProps.cue[key] === nextProps.cue[key]);

  return topLevelEqual && cueEqual;
}